var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import AssignLead from "./AssignLead";
import di from "./di/serviceLocator";
import { useSelector } from "react-redux";
import Loader, { LogoLoader, } from "@frameworks/shared-library/components/Loader";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import { Link, useNavigate } from "react-router-dom";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
import { getDateInFormat } from "@domains/utils/reportDates";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import { assignedToGroupKey, jointTabKey, singleDigitToDoubleDigit, } from "./constant";
import useStickyHeader from "@frameworks/shared-library/utils/useStickyHeader";
import { addCommasWithoutDecimal } from "@domains/utils/numberMethods";
import Arrows from "@frameworks/web/components/generic/TableHeaderArrows";
import SalesToasts from "@frameworks/shared-library/components/Toasts";
import { toCamelCase } from "@domains/utils/stringMethods";
import EdModal from "@frameworks/web/components/generic/edModal";
import AssignLeadPopup from "./AssignLeadPopup";
import config from "@frameworks/salesjourney/config/domain";
import CustomPagination from "@frameworks/shared-library/components/CustomPagination";
import loginDi from "@frameworks/salesjourney/components/Login/di/index";
import ViewLeadNew from "./ViewLeadNew";
import { IEditLeadAccessPayloadEnum } from "@domains/salesFeatures/Lead/entities/IEditLeadAccess";
import { getInterestedPriorityTag } from "@frameworks/salesjourney/components/constant";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import ClientTier from "@frameworks/salesjourney/components/Generic/ClientTier";
import GenericTabs from "@frameworks/shared-library/components/GenericTabs";
import ViewMom from "./ViewMom";
import { getSortedData } from "@domains/utils/sort";
import SalesWarningPopup from "@frameworks/shared-library/components/SalesWarningPopup";
export var EActiveProductFeedbackTab;
(function (EActiveProductFeedbackTab) {
    EActiveProductFeedbackTab["LIKED_FEEDBACK"] = "LIKED_FEEDBACK";
    EActiveProductFeedbackTab["DISLIKED_FEEDBACK"] = "DISLIKED_FEEDBACK";
    EActiveProductFeedbackTab["OTHER_FEEDBACK"] = "OTHER_FEEDBACK";
})(EActiveProductFeedbackTab || (EActiveProductFeedbackTab = {}));
var columnList = [
    {
        title: "Client Details",
        key: "fullname",
        type: "string",
        arrows: true,
        applySorting: true,
    },
    {
        title: "Category",
        key: "categoryName",
        type: "string",
        arrows: true,
        applySorting: true,
    },
    {
        title: "Scheme",
        key: "scheme",
        type: "string",
        arrows: true,
        applySorting: true,
    },
    // { title: "Client UCC" },
    {
        title: "Amount Pipeline",
        arrows: true,
        key: "pipeline",
        type: "number",
        applySorting: true,
    },
    {
        title: "Status",
        arrows: true,
        key: "status",
        type: "string",
        applySorting: true,
    },
    {
        title: "Interaction Status/ Sub Status",
        arrows: true,
        key: "interactionStatus",
        type: "string",
        applySorting: true,
    },
    {
        title: "Followup Date",
        arrows: true,
        key: "followupDate",
        type: "string",
        applySorting: true,
    },
    { title: "Action" },
];
var LeadTableNPagination = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    var _w = __read(useState(false), 2), reassignLeadParentLoader = _w[0], setReassignLeadParentLoader = _w[1];
    var _x = __read(useState(false), 2), reassignLeadChildLoader = _x[0], setReassignLeadChildLoader = _x[1];
    var _y = __read(React.useState(false), 2), editAccessToast = _y[0], setEditAccessToast = _y[1];
    var _z = __read(React.useState({
        isEditAccessErrorState: false,
        isEditAccessLoader: false,
        editAccessMsg: "",
    }), 2), editAccessUiState = _z[0], setEditAccessUiState = _z[1];
    var stickyHeader = useStickyHeader(400);
    var headerClasses = stickyHeader ? "lead-table-sticky" : "";
    var _0 = __read(React.useState(false), 2), assignToMe = _0[0], setAssignToMe = _0[1];
    var _1 = __read(React.useState(""), 2), isSearchEmp = _1[0], setIsSearchEmp = _1[1];
    var myRef = useRef(null);
    var headRef = useRef(null);
    var executeScroll = function () {
        return myRef.current.scrollIntoView({ behavior: "smooth" });
    };
    var _2 = __read(useState([]), 2), tableData = _2[0], setTableData = _2[1];
    var _3 = __read(useState({
        key: "",
        dataType: "",
    }), 2), sortType = _3[0], setSortType = _3[1];
    var _4 = __read(useState(false), 2), sortingType = _4[0], setSortingType = _4[1];
    var navigate = useNavigate();
    var _5 = __read(useState(), 2), selectedLead = _5[0], setSelectedLead = _5[1];
    var _6 = __read(React.useState(false), 2), selfAssignLoader = _6[0], setSelfAssignLoader = _6[1];
    var _7 = __read(React.useState(false), 2), successSelfAssign = _7[0], setSuccessSelfAssign = _7[1];
    var _8 = __read(React.useState(false), 2), isAssignError = _8[0], setIsAssignError = _8[1];
    var _9 = __read(React.useState(""), 2), successSelfAssignMsg = _9[0], setSuccessSelfAssignMsg = _9[1];
    var _10 = __read(useState(), 2), leadId = _10[0], setLeadId = _10[1];
    var _11 = __read(useState(), 2), leadOwner = _11[0], setLeadOwner = _11[1];
    var _12 = __read(React.useState(false), 2), assignLead = _12[0], setAssignLead = _12[1];
    var _13 = __read(React.useState(false), 2), showSucess = _13[0], setShowSuccess = _13[1];
    var _14 = __read(React.useState(""), 2), showAssignMsg = _14[0], setShowAssingMsg = _14[1];
    var _15 = __read(React.useState(false), 2), viewLead = _15[0], setViewLead = _15[1];
    var _16 = __read(React.useState(false), 2), loader = _16[0], setLoader = _16[1];
    var _17 = __read(React.useState({
        internalComments: [],
        totalCommentsCount: 0,
    }), 2), internalComments = _17[0], setInternalComments = _17[1];
    var _18 = __read(React.useState(0), 2), totalInternalCommentsCount = _18[0], setTotalInternalCommentsCount = _18[1];
    //const [internalCommentsError, setInternalCommentsError] = React.useState("");
    var _19 = __read(React.useState([
        false,
    ]), 2), viewInnerTable = _19[0], setViewInnerTable = _19[1];
    var _20 = __read(useState(null), 2), clickedIndex = _20[0], setClickedIndex = _20[1];
    var _21 = __read(useState(false), 2), isShowProductFeedbackModal = _21[0], setIsShowProductFeedbackModal = _21[1];
    var _22 = __read(useState({
        likedData: { count: 0, feedback: [] },
        dislikedData: { count: 0, feedback: [] },
        otherData: { count: 0, feedback: [] },
    }), 2), productFeedbackModalData = _22[0], setProductFeedbackModalData = _22[1];
    var _23 = __read(useState(EActiveProductFeedbackTab.LIKED_FEEDBACK), 2), productFeedbackActiveTab = _23[0], setProductFeedbackActiveTab = _23[1];
    var _24 = __read(useState(false), 2), viewMom = _24[0], setViewMom = _24[1];
    var _25 = __read(useState(false), 2), momViewLoader = _25[0], setMomViewLoader = _25[1];
    var _26 = __read(useState([]), 2), momViewDetails = _26[0], setMomViewDetails = _26[1];
    var _27 = __read(useState(""), 2), momMailText = _27[0], setMomMailText = _27[1];
    var _28 = __read(useState(), 2), orderIdPopUpInfo = _28[0], setOrderIdPopUpInfo = _28[1];
    var productFeedbackTabs = [
        {
            eventKey: EActiveProductFeedbackTab.LIKED_FEEDBACK,
            title: (React.createElement("div", { className: "d-flex align-items-center gap-2" },
                React.createElement("i", { className: "edel-icon-like" }),
                React.createElement("div", null, singleDigitToDoubleDigit((_a = productFeedbackModalData === null || productFeedbackModalData === void 0 ? void 0 : productFeedbackModalData.likedData) === null || _a === void 0 ? void 0 : _a.count)))),
            tabContent: (React.createElement("div", { className: "d-flex flex-column product-feedback-tabs-data" }, ((_b = productFeedbackModalData === null || productFeedbackModalData === void 0 ? void 0 : productFeedbackModalData.likedData) === null || _b === void 0 ? void 0 : _b.feedback.length) > 0 ? ((_d = (_c = productFeedbackModalData === null || productFeedbackModalData === void 0 ? void 0 : productFeedbackModalData.likedData) === null || _c === void 0 ? void 0 : _c.feedback) === null || _d === void 0 ? void 0 : _d.map(function (item) {
                return (React.createElement("span", { className: "individual-feedback-item txt-midnight-blue DMSansNormal_12_400" }, item));
            })) : (React.createElement("div", { className: "p-3 DMSansNormal_12_400 txt-midnight-blue no-comments" },
                React.createElement("span", null, "There are no comments here yet"))))),
        },
        {
            eventKey: EActiveProductFeedbackTab.DISLIKED_FEEDBACK,
            title: (React.createElement("div", { className: "d-flex align-items-center gap-2" },
                React.createElement("i", { className: "edel-icon-dislike1" }),
                React.createElement("div", null, singleDigitToDoubleDigit((_e = productFeedbackModalData === null || productFeedbackModalData === void 0 ? void 0 : productFeedbackModalData.dislikedData) === null || _e === void 0 ? void 0 : _e.count)))),
            tabContent: (React.createElement("div", { className: "d-flex flex-column product-feedback-tabs-data" }, ((_f = productFeedbackModalData === null || productFeedbackModalData === void 0 ? void 0 : productFeedbackModalData.dislikedData) === null || _f === void 0 ? void 0 : _f.feedback.length) > 0 ? ((_h = (_g = productFeedbackModalData === null || productFeedbackModalData === void 0 ? void 0 : productFeedbackModalData.dislikedData) === null || _g === void 0 ? void 0 : _g.feedback) === null || _h === void 0 ? void 0 : _h.map(function (item) {
                return (React.createElement("span", { className: "individual-feedback-item txt-midnight-blue DMSansNormal_12_400" }, item));
            })) : (React.createElement("div", { className: "p-3 DMSansNormal_12_400 txt-midnight-blue no-comments" },
                React.createElement("span", null, "There are no comments here yet"))))),
        },
        {
            eventKey: EActiveProductFeedbackTab.OTHER_FEEDBACK,
            title: (React.createElement("div", { className: "d-flex align-items-center gap-2" },
                React.createElement("i", { className: "edel-icon-round-circle txt_rich-electric-blue" }),
                React.createElement("div", null, singleDigitToDoubleDigit((_j = productFeedbackModalData === null || productFeedbackModalData === void 0 ? void 0 : productFeedbackModalData.otherData) === null || _j === void 0 ? void 0 : _j.count)))),
            tabContent: (React.createElement("div", { className: "d-flex flex-column product-feedback-tabs-data" }, ((_k = productFeedbackModalData === null || productFeedbackModalData === void 0 ? void 0 : productFeedbackModalData.otherData) === null || _k === void 0 ? void 0 : _k.feedback.length) > 0 ? ((_m = (_l = productFeedbackModalData === null || productFeedbackModalData === void 0 ? void 0 : productFeedbackModalData.otherData) === null || _l === void 0 ? void 0 : _l.feedback) === null || _m === void 0 ? void 0 : _m.map(function (item) {
                return (React.createElement("span", { className: "individual-feedback-item txt-midnight-blue DMSansNormal_12_400" }, item));
            })) : (React.createElement("div", { className: "p-3 DMSansNormal_12_400 txt-midnight-blue no-comments" },
                React.createElement("span", null, "There are no comments here yet"))))),
        },
    ];
    var handleArrowClick = function (index) {
        setClickedIndex(index);
    };
    var reassignLead = function () {
        if (leadOwner) {
            var nameId = leadOwner === null || leadOwner === void 0 ? void 0 : leadOwner.name.split("(");
            var name_1 = nameId[0];
            var id = leadOwner.id;
            var requestPayload = {
                leadId: leadId,
                dealerEmpCode: id,
                dealerCodeName: leadOwner === null || leadOwner === void 0 ? void 0 : leadOwner.name,
                remarks: "",
            };
            di.leads.reassignLead(requestPayload).then(function (leadResponse) {
                if (leadResponse) {
                    setShowSuccess(true);
                    setAssignLead(false);
                    setShowAssingMsg("Assign Lead Sucessfully");
                    props.refreshLeadFunction();
                }
            });
        }
    };
    var userId = useSelector(function (state) { var _a, _b; return (_b = (_a = state.Profile.ProfileDetails.reducersData.data) === null || _a === void 0 ? void 0 : _a.profileDetails) === null || _b === void 0 ? void 0 : _b.userId; });
    var setAssignLeadFunction = function (selectedRow) {
        setViewLead(false);
        setAssignLead(true);
        setLeadOwner({
            leadOwnerCode: selectedRow.dealerEmpCode,
            leadOwnerName: selectedRow.dealerEmpName,
            leadId: selectedRow.leadId,
        });
        setLeadId(selectedRow.leadId);
    };
    var getSelectedLeadId = function (selectedRow) {
        setLeadOwner({
            leadOwnerCode: selectedRow.dealerEmpCode,
            leadOwnerName: selectedRow.dealerEmpName,
            leadId: selectedRow.leadId,
        });
        setLeadId(selectedRow.leadId);
    };
    var isAuthorizedToAssignLead = function (leadId, calledFromChild) {
        if (calledFromChild)
            setReassignLeadChildLoader(true);
        else
            setReassignLeadParentLoader(true);
        return di.leads
            .isAuthorizedToAssignLead(leadId)
            .then(function (response) {
            if (response.success && response.data.response) {
                setReassignLeadChildLoader(false);
                setReassignLeadParentLoader(false);
                return true;
            }
            else if (response.success && !response.data.response) {
                setReassignLeadChildLoader(false);
                setReassignLeadParentLoader(false);
                setSuccessSelfAssign(true);
                setIsAssignError(true);
                setSuccessSelfAssignMsg(response.data.responseDescription);
                return false;
            }
        })
            .catch(function (error) {
            console.log("Error for reassign====", error);
            setReassignLeadChildLoader(false);
            setReassignLeadParentLoader(false);
            return false;
        });
    };
    var getSelfAssign = function (callBackFunction) {
        setSelfAssignLoader(true);
        di.leads
            .getSelfAssignDetails({ LeadId: selectedLead.leadId })
            .then(function (resp) {
            setViewLead(false);
            setAssignToMe(false);
            if (resp && resp.success && resp.response === "Success") {
                setSuccessSelfAssign(true);
                setIsAssignError(false);
                setSelfAssignLoader(false);
                setSuccessSelfAssignMsg(resp.responseDescription);
                callBackFunction();
            }
            else {
                setSuccessSelfAssign(true);
                setIsAssignError(true);
                setSelfAssignLoader(false);
                setSuccessSelfAssignMsg(resp.responseDescription);
            }
        })
            .catch(function (error) {
            setViewLead(false);
            setAssignToMe(false);
            setSuccessSelfAssign(true);
            setIsAssignError(true);
            setSelfAssignLoader(false);
            setSuccessSelfAssignMsg("Something is wrong please try again later.");
        });
    };
    var getLeadId = function (selectedRow) {
        setLeadId(selectedRow.leadId);
    };
    React.useEffect(function () {
        var _a;
        if (props === null || props === void 0 ? void 0 : props.leadDetails) {
            applySortingAccordingKey(sortType.key, sortType.dataType, sortingType, (_a = props === null || props === void 0 ? void 0 : props.leadDetails) === null || _a === void 0 ? void 0 : _a.leadDashboardList);
            // setTableData(props?.leadDetails?.leadDashboardList);
        }
    }, [(_o = props === null || props === void 0 ? void 0 : props.leadDetails) === null || _o === void 0 ? void 0 : _o.leadDashboardList]);
    var applySortingAccordingKey = function (key, dataType, sortType, data) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            setSortingType(sortType);
            setSortType({
                key: key,
                dataType: dataType,
            });
            result = getSortedData((_a = (data ? data : tableData)) === null || _a === void 0 ? void 0 : _a.map(function (lead) {
                var _a;
                return (__assign(__assign({}, lead), { fullname: (_a = lead === null || lead === void 0 ? void 0 : lead.fullname) === null || _a === void 0 ? void 0 : _a.toUpperCase() }));
            }), sortType, key, dataType);
            setTableData(result);
            return [2 /*return*/];
        });
    }); };
    var getShowEdit = function (record, flag) {
        var showEdit = true;
        //    let showEditObj = {showEdit:true,showEditLoader:loader};
        // if (
        //   !(
        //     leadStatusConfig.leadSource &&
        //     leadStatusConfig.leadSource.length > 0 &&
        //     leadStatusConfig.leadSource.includes(record.leadSource)
        //   )
        // ) {
        //   return false;
        // }
        // if (props.leadTabFlag === assignedByMeGroupKey) {
        //   showEdit = false;
        // } else {
        //   showEdit = false;
        //   if (userId !== null) {
        //     if (userId === record.dealerEmpCode) showEdit = true;
        //     if (
        //       record.primaryOwner !== null &&
        //       userId.toString() === record.primaryOwner.code
        //     ) {
        //       showEdit = true;
        //     }
        //   }
        // }
        // // if (
        // //   record.subStatusId !== undefined &&
        // //   record.subStatusId !== null &&
        // //   record.interaction_sub_statusid !== undefined &&
        // //   record.interaction_sub_statusid !== undefined &&
        // //   record.subStatusId &&
        // //   record.interaction_sub_statusid &&
        // //   record.subStatusId.toString() ===
        // //     leadStatusConfig.interestedInteractionStatusId &&
        // //   record.interaction_sub_statusid.toString() ===
        // //     leadStatusConfig.convertedInteractionSubStatusId
        // // ) {
        // //   showEdit = false;
        // // }
        // // if (
        // //   record.subStatusId !== undefined &&
        // //   record.subStatusId !== null &&
        // //   record.interaction_sub_statusid !== undefined &&
        // //   record.interaction_sub_statusid !== undefined &&
        // //   record.subStatusId &&
        // //   record.interaction_sub_statusid &&
        // //   record.subStatusId.toString() ===
        // //     leadStatusConfig.interestedInteractionStatusId &&
        // //   record.interaction_sub_statusid.toString() ===
        // //     leadStatusConfig.notConvertedInteractionSubStatusId
        // // ) {
        // //   showEdit = false;
        // // }
        // // if (
        // //   record.subStatusId !== undefined &&
        // //   record.subStatusId !== null &&
        // //   record.subStatusId &&
        // //   (record.subStatusId.toString() ===
        // //     leadStatusConfig.notInterestedInteractionStatusId ||
        // //     record.subStatusId === leadStatusConfig.completedInteractionStatusId ||
        // //     record.subStatusId === leadStatusConfig.notCompletedInteractionStatusId)
        // // ) {
        // //   showEdit = false;
        // // }
        // // if (
        // //   record.statusId !== undefined &&
        // //   record.statusId !== null &&
        // //   (record.statusId.toString() ===
        // //     leadStatusConfig.wonConvertedStatusIdForLead ||
        // //     record.statusId.toString() ===
        // //       leadStatusConfig.lostNotConveretdStatusIdForLead ||
        // //     record.statusId.toString() ===
        // //       leadStatusConfig.expiredNotConvertedStatusIdForLead)
        // // ) {
        // //   showEdit = false;
        // // }
        // if (
        //   (!!record.statusId &&
        //     record.statusId.toString() ===
        //       leadStatusConfig.wonConvertedStatusIdForLead) ||
        //   record.statusId.toString() ===
        //     leadStatusConfig.lostNotConveretdStatusIdForLead
        // ) {
        //   showEdit = false;
        // }
        // showEditObj.showEditLoader=true;
        setEditAccessUiState(function (editAccessUiState) {
            editAccessUiState.isEditAccessLoader = true;
            return editAccessUiState;
        });
        di.leads
            .editAccessLead({ strLeadId: record.leadId, strFlag: flag })
            .then(function (resp) {
            if (resp && resp.response) {
                showEdit = resp.response;
                //   showEditObj.showEditLoader=false;
                setEditAccessUiState(function (editAccessUiState) {
                    editAccessUiState.isEditAccessLoader = false;
                    return editAccessUiState;
                });
                if (flag === IEditLeadAccessPayloadEnum.EDIT_FLAG) {
                    // window.open(getEditLeadURL(record), "_blank");
                    // navigate(getEditLeadURL(record), {
                    //   state:getStateObject(),
                    // });
                    // window.open(getEditLeadURL(record), "_self");
                }
                else {
                    // window.open(getSplitLeadURL(record), "_blank");
                    navigate(getSplitLeadURL(record), {
                        state: getStateObject(),
                    });
                    // window.open(getSplitLeadURL(record), "_self");
                }
            }
            else {
                showEdit = false;
                //showEditObj.showEditLoader=false;
                if (resp && (resp === null || resp === void 0 ? void 0 : resp.responseDescription)) {
                    setEditAccessUiState(function (editAccessUiState) {
                        editAccessUiState.editAccessMsg = (resp === null || resp === void 0 ? void 0 : resp.responseDescription)
                            ? resp === null || resp === void 0 ? void 0 : resp.responseDescription
                            : "Something went wrong. please try agian later";
                        editAccessUiState.isEditAccessErrorState = true;
                        editAccessUiState.isEditAccessLoader = false;
                        return editAccessUiState;
                    });
                    setEditAccessToast(true);
                }
                else {
                    setEditAccessUiState(function (editAccessUiState) {
                        editAccessUiState.editAccessMsg =
                            flag === IEditLeadAccessPayloadEnum.EDIT_FLAG
                                ? "Unauthorised for Edit"
                                : "Unauthorised for Split";
                        editAccessUiState.isEditAccessErrorState = true;
                        editAccessUiState.isEditAccessLoader = false;
                        return editAccessUiState;
                    });
                    setEditAccessToast(true);
                }
            }
        })
            .catch(function (error) {
            setEditAccessToast(true);
            // showEditObj.showEdit = false;
            setEditAccessUiState(function (editAccessUiState) {
                editAccessUiState.editAccessMsg =
                    "Something went wrong.please try again later";
                editAccessUiState.isEditAccessErrorState = true;
                editAccessUiState.isEditAccessLoader = false;
                return editAccessUiState;
            });
        });
        return showEdit;
    };
    var getStateObject = function () {
        var currentUrl = window.location.href;
        var _a = __read(currentUrl.split("?"), 2), baseUrl = _a[0], queryString = _a[1];
        var state = {
            param: queryString,
            leadTableTab: props === null || props === void 0 ? void 0 : props.leadTabFlag,
        };
        return state;
    };
    var getEditLeadURL = function (x) {
        var editUrl = "/dashboard/leadpage/" +
            window.btoa(x === null || x === void 0 ? void 0 : x.leadId) +
            "/" +
            window.btoa(String(x === null || x === void 0 ? void 0 : x.isClient)) +
            "/" +
            window.btoa(String(x === null || x === void 0 ? void 0 : x.isParent));
        return editUrl;
    };
    var getSplitLeadURL = function (x) {
        var editUrl = "/dashboard/leadpage/" +
            window.btoa(null) +
            "/" +
            window.btoa(String(true)) +
            "/" +
            window.btoa(String(true)) +
            "/" +
            window.btoa(x === null || x === void 0 ? void 0 : x.leadId);
        return editUrl;
    };
    var getClientSearchDataList = function (searchText, isClient) {
        var url = "";
        url =
            config.applicationFolder +
                "clientdetails/overview?link=".concat(isClient ? "overview" : "profile", "&uccCode=").concat(window.btoa(searchText));
        return url;
    };
    var getMomViewDetails = function (leadId) {
        setMomViewLoader(true);
        di.leads
            .getViewMomDetails({ leadid: leadId })
            .then(function (resp) {
            var _a, _b;
            if (resp === null || resp === void 0 ? void 0 : resp.data) {
                setMomViewDetails(resp === null || resp === void 0 ? void 0 : resp.data);
                setMomMailText(atob((_b = (_a = resp === null || resp === void 0 ? void 0 : resp.data[0]) === null || _a === void 0 ? void 0 : _a.mailDetail) === null || _b === void 0 ? void 0 : _b.filebase64).replace(/ï»¿/g, ""));
            }
            setMomViewLoader(false);
        })
            .catch(function (err) {
            setMomViewLoader(false);
        });
    };
    var leadRedireactionForOrderID = function () {
        setOrderIdPopUpInfo(function (prev) { return (__assign(__assign({}, prev), { isShow: false })); });
        window.open(orderIdPopUpInfo === null || orderIdPopUpInfo === void 0 ? void 0 : orderIdPopUpInfo.url, "_blank");
    };
    return (React.createElement(React.Fragment, null,
        reassignLeadParentLoader && React.createElement(LogoLoader, null),
        React.createElement("div", { className: "all-leads-table p-0" },
            React.createElement("div", { className: " all-leads-table-head sticky-table-head DMSansMedium_12_500 txt_primaryGrey ".concat(headerClasses), ref: headRef },
                React.createElement("div", { className: "border-row" },
                    React.createElement("div", { className: "all-leads-table-head-row" }, columnList.map(function (column, idx) {
                        return (React.createElement("div", { className: "all-leads-table-head-row-cell txt_black-seven DMSansMedium_12_500", key: idx, onClick: function () {
                                handleArrowClick(idx);
                                (column === null || column === void 0 ? void 0 : column.applySorting)
                                    ? applySortingAccordingKey(column.key, column.type, !sortingType)
                                    : null;
                            } }, (column === null || column === void 0 ? void 0 : column.arrows) ? (React.createElement(Arrows, { sortType: sortingType, key: column === null || column === void 0 ? void 0 : column.key, title: column.title, isClicked: idx === clickedIndex })) : (column.title)));
                    })))),
            React.createElement("div", { className: " all-leads-table-body DMSanN_14_400 txt_blackOne1" },
                ((_p = props === null || props === void 0 ? void 0 : props.errorData) === null || _p === void 0 ? void 0 : _p.isOpen) && (React.createElement(ErrorNotification, { error: (_q = props === null || props === void 0 ? void 0 : props.errorData) === null || _q === void 0 ? void 0 : _q.error, isOpen: (_r = props === null || props === void 0 ? void 0 : props.errorData) === null || _r === void 0 ? void 0 : _r.isOpen, displayType: ErrorDisplayType.INSECTION })),
                (props === null || props === void 0 ? void 0 : props.loader) && (React.createElement("div", { className: "border-0 loader-height-row w-100" },
                    React.createElement("div", { className: "position-relative loader-lead border-0" },
                        React.createElement(LogoLoader, null)))),
                !((_s = props === null || props === void 0 ? void 0 : props.errorData) === null || _s === void 0 ? void 0 : _s.isOpen) &&
                    !(props === null || props === void 0 ? void 0 : props.loader) &&
                    tableData &&
                    (tableData === null || tableData === void 0 ? void 0 : tableData.length) > 0 ? (tableData.map(function (x) {
                    var _a;
                    var showEdit = false, showEditLoader = false;
                    return (React.createElement("div", { className: "border-row d-flex align-items-center hover-effect ".concat((x === null || x === void 0 ? void 0 : x.orderId) ? "hand_cursor bg_fantasy" : "hand_cursor"), key: x.leadId },
                        React.createElement(ClientTier, { showOnlyIcon: false, tierTextClass: "DMsanR_08_400", hoverClass: true, clientTier: x === null || x === void 0 ? void 0 : x.clientTier }),
                        React.createElement("div", { className: "no-client-tier" }),
                        React.createElement("div", { className: "all-leads-table-body-row ", onClick: function () {
                                setViewLead(true);
                                setSelectedLead(x);
                            } },
                            React.createElement("div", { className: "" },
                                React.createElement("div", { className: "d-flex flex-column justify-content-evenly" },
                                    React.createElement("span", { className: "DMSansNormal_12_400 d-flex align-items-center" }, x === null || x === void 0 ? void 0 :
                                        x.leadId,
                                        "\u00A0",
                                        React.createElement("span", { className: "d-flex align-items-center gap-1 " },
                                            x.isParent && (React.createElement("div", { onClick: function (e) {
                                                    e.stopPropagation();
                                                    props === null || props === void 0 ? void 0 : props.setLeadIdSearch(x === null || x === void 0 ? void 0 : x.leadId);
                                                }, className: "d-flex align-items-center gap-1" },
                                                React.createElement("i", { className: "edel-icon-round-circle" }),
                                                React.createElement("i", { className: "edel-icon-community" }),
                                                React.createElement("span", { className: "txt-midnight-blue" }, "Partner"))),
                                            !!(x === null || x === void 0 ? void 0 : x.isNew) &&
                                                ((_a = x === null || x === void 0 ? void 0 : x.isNew) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                                (x === null || x === void 0 ? void 0 : x.isNew) === "New" && (React.createElement(React.Fragment, null,
                                                React.createElement("i", { className: "edel-icon-round-circle" }),
                                                React.createElement("span", { className: "is-new-box" }, "NEW"))),
                                            (x === null || x === void 0 ? void 0 : x.isCritical) && (React.createElement(GenericTooltip, { placement: "bottom", toolTipText: "Urgent", triggerType: "hover", toolTipClassName: "lead-table-tooltip", noButton: true, button: React.createElement("i", { className: "edel-icon-urgent-1" }) })),
                                            (x === null || x === void 0 ? void 0 : x.interaction_priority_id) &&
                                                getInterestedPriorityTag(x === null || x === void 0 ? void 0 : x.interaction_priority_id))),
                                    React.createElement("span", { className: "DMSan_14_700 text-break", title: toCamelCase(x === null || x === void 0 ? void 0 : x.taskDescription) }, (x === null || x === void 0 ? void 0 : x.clientType) === "Lead" ||
                                        (x === null || x === void 0 ? void 0 : x.clientType) === "Partner Lead" ? (React.createElement(React.Fragment, null, (x === null || x === void 0 ? void 0 : x.fullname) ? toCamelCase(x === null || x === void 0 ? void 0 : x.fullname) : "-")) : (React.createElement(React.Fragment, null,
                                        React.createElement("a", { href: getClientSearchDataList(x === null || x === void 0 ? void 0 : x.uccCode, x === null || x === void 0 ? void 0 : x.isClient), className: "txt_black text-decoration-underline", onClick: function (e) {
                                                e.stopPropagation();
                                                // getClientSearchDataList(x?.uccCode);
                                            } }, (x === null || x === void 0 ? void 0 : x.fullname) ? toCamelCase(x === null || x === void 0 ? void 0 : x.fullname) : "-")))),
                                    React.createElement("span", { className: "DMSanN_14_400 " }, toCamelCase(x === null || x === void 0 ? void 0 : x.clientType)))),
                            React.createElement("div", { className: "", title: x === null || x === void 0 ? void 0 : x.categoryName },
                                React.createElement("div", { className: "DMSansNormal_12_400 ellipsis" },
                                    React.createElement("span", { className: "" }, (x === null || x === void 0 ? void 0 : x.categoryName) ? x === null || x === void 0 ? void 0 : x.categoryName : "-"))),
                            React.createElement("div", { className: "", title: x === null || x === void 0 ? void 0 : x.displayName },
                                React.createElement("div", { className: "DMSansNormal_12_400" },
                                    React.createElement("span", null, (x === null || x === void 0 ? void 0 : x.bucketId) == (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.engagementBucketId)
                                        ? (x === null || x === void 0 ? void 0 : x.subCategoryName)
                                            ? x === null || x === void 0 ? void 0 : x.subCategoryName
                                            : "-"
                                        : (x === null || x === void 0 ? void 0 : x.displayName)
                                            ? x === null || x === void 0 ? void 0 : x.displayName
                                            : "-"))),
                            React.createElement("div", { className: " text-truncate" },
                                React.createElement("div", { className: "RobotoR_14_400" }, (x === null || x === void 0 ? void 0 : x.pipeline)
                                    ? addCommasWithoutDecimal(x === null || x === void 0 ? void 0 : x.pipeline)
                                    : "-")),
                            React.createElement("div", { className: " text-truncate", title: x === null || x === void 0 ? void 0 : x.status },
                                React.createElement("div", { className: "DMSansNormal_12_400" },
                                    React.createElement("span", null,
                                        " ",
                                        (x === null || x === void 0 ? void 0 : x.status) ? x === null || x === void 0 ? void 0 : x.status : "-"))),
                            React.createElement("div", { className: "text-truncate", title: x === null || x === void 0 ? void 0 : x.interactionStatus },
                                React.createElement("div", { className: "d-flex gap-2 flex-column justify-content-center DMSansNormal_12_400" },
                                    React.createElement("span", null, (x === null || x === void 0 ? void 0 : x.interactionStatus) ? x === null || x === void 0 ? void 0 : x.interactionStatus : "-"),
                                    React.createElement("span", null, (x === null || x === void 0 ? void 0 : x.interaction_sub_status)
                                        ? x === null || x === void 0 ? void 0 : x.interaction_sub_status
                                        : "-"))),
                            React.createElement("div", { className: "text-truncate" },
                                React.createElement("div", { className: "DMSanN_14_400" }, (x === null || x === void 0 ? void 0 : x.followupDate)
                                    ? getDateInFormat(x === null || x === void 0 ? void 0 : x.followupDate, "DD MMM YY")
                                    : "-")),
                            React.createElement("div", { className: "" }, props.leadTabFlag === assignedToGroupKey ? (React.createElement("div", { className: "assign-person" },
                                React.createElement("i", { className: "edel-icon-assign" }))) : (React.createElement("div", { className: "d-flex icons justify-content-between align-items-center " },
                                React.createElement(Link, { to: getEditLeadURL(x), state: getStateObject(), onClick: function (e) {
                                        e.stopPropagation();
                                    } },
                                    React.createElement("i", { className: (x === null || x === void 0 ? void 0 : x.statusId.toString()) ===
                                            leadStatusConfig.expiredNotConvertedStatusIdForLead
                                            ? "edel-icon-double-refresh "
                                            : "edel-icon-edit-icon-large hand_cursor" })),
                                !loginDi.login.getIsRMPartnerFRM().isPartner && (React.createElement("i", { onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                                        var _a;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    e.stopPropagation();
                                                    _a = props.leadTabFlag !== jointTabKey;
                                                    if (!_a) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, isAuthorizedToAssignLead(x.leadId, false)];
                                                case 1:
                                                    _a = (_b.sent());
                                                    _b.label = 2;
                                                case 2:
                                                    if (_a) {
                                                        setAssignLead(true);
                                                        getSelectedLeadId(x);
                                                        getLeadId(x);
                                                    }
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }, className: "edel-icon-profile-refresh hand_cursor" })),
                                (x === null || x === void 0 ? void 0 : x.isParent) &&
                                    ((x === null || x === void 0 ? void 0 : x.parentLeadId) === null ||
                                        (x === null || x === void 0 ? void 0 : x.parentLeadId) === undefined ||
                                        (x === null || x === void 0 ? void 0 : x.parentLeadId) === "") ? (React.createElement("i", { className: "edel-icon-split hand_cursor", onClick: function (e) {
                                        e.stopPropagation();
                                        if ((x === null || x === void 0 ? void 0 : x.isParent) &&
                                            ((x === null || x === void 0 ? void 0 : x.parentLeadId) === null ||
                                                (x === null || x === void 0 ? void 0 : x.parentLeadId) === undefined ||
                                                (x === null || x === void 0 ? void 0 : x.parentLeadId) === "") &&
                                            !(x.statusId.toString() ===
                                                (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.wonConvertedStatusIdForLead) ||
                                                x.statusId.toString() ===
                                                    (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.lostNotConveretdStatusIdForLead) ||
                                                x.statusId.toString() ===
                                                    (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.expiredNotConvertedStatusIdForLead)))
                                            getShowEdit(x, IEditLeadAccessPayloadEnum.SPLIT_FLAG);
                                        // navigate(
                                        //   "/dashboard/leadpage/" + btoa(x?.leadId),
                                        //   {
                                        //     replace: true,
                                        //     state: {
                                        //       joint:
                                        //         userId ===
                                        //         Number(x?.primaryOwner?.code),
                                        //     },
                                        //   }
                                        // );
                                    } })) : (React.createElement(React.Fragment, null,
                                    React.createElement("i", null),
                                    React.createElement("i", null)))))))));
                })) : (React.createElement("div", { className: "table-errormsg" },
                    React.createElement("div", { className: "w-100" },
                        React.createElement("div", { className: "d-flex justify-content-center" }, !(props === null || props === void 0 ? void 0 : props.loader) && (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })))))),
                (props === null || props === void 0 ? void 0 : props.loader) && (tableData === null || tableData === void 0 ? void 0 : tableData.length) > 15 && (React.createElement("div", { className: "border-0" },
                    React.createElement("div", { className: "position-relative loader-lead border-0 text-center" },
                        React.createElement(Loader, null)))),
                ((_t = props.leadDetails) === null || _t === void 0 ? void 0 : _t.totalpages) > 1 && (React.createElement("div", { className: "pagination-footer" },
                    React.createElement(CustomPagination, { totalPages: (_u = props.leadDetails) === null || _u === void 0 ? void 0 : _u.totalpages, getData: function (pageNumber) {
                            props.getCurretPageLeads(pageNumber);
                        }, bubbleClassName: null, activePageClassName: null, currentPage: (_v = props.leadDetails) === null || _v === void 0 ? void 0 : _v.currentpage }))))),
        React.createElement(GenericSidebar, { parentClassname: "lead-table-sidebar", header: React.createElement("div", { className: "bg_aqua_white lead-sidebar-head DMSans_16_500 txt_blackOne1" }, "Assign Lead To"), body: leadOwner && (React.createElement(AssignLead, { isSearchEmp: setIsSearchEmp, passEMPData: setLeadOwner, leadOwnerCode: leadOwner.leadOwnerCode, leadOwnerName: leadOwner.leadOwnerName })), footer: React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Assign", className: "w-100 assign-lead", onClick: function () {
                    //setAssignLead(false);
                    reassignLead();
                }, disabled: (leadOwner === null || leadOwner === void 0 ? void 0 : leadOwner.id) && (leadOwner === null || leadOwner === void 0 ? void 0 : leadOwner.name) && isSearchEmp !== ""
                    ? false
                    : true }), openKey: assignLead, setOpenKey: setAssignLead, arrowClose: true, delay: 10 }),
        viewLead && (React.createElement(GenericSidebar, { parentClassname: "view-lead-sidebar", header: React.createElement("div", { className: "d-flex justify-content-between align-items-center " },
                React.createElement("div", { className: " lead-sidebar-head DMSans_16_500 txt_blackOne1 d-flex align-items-center" },
                    React.createElement("span", { className: "me-2" }, "View Lead"),
                    (selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.isCritical) && (React.createElement(GenericTooltip, { placement: "bottom", toolTipText: "Urgent", triggerType: "hover", toolTipClassName: "lead-table-tooltip", noButton: true, button: React.createElement("i", { className: "edel-icon-urgent-1 me-1" }) })),
                    React.createElement("span", { className: "d-flex" }, (selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.interaction_priority_id) &&
                        getInterestedPriorityTag(selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.interaction_priority_id)))), body: React.createElement(React.Fragment, null, React.createElement(ViewLeadNew, { reassignLeadChildLoader: reassignLeadChildLoader, isAuthorizedToAssignLead: isAuthorizedToAssignLead, setAssignLead: setAssignLeadFunction, leadAssign: selectedLead, leadTabFlag: props.leadTabFlag, getShowEdit: getShowEdit, assigntoMePopup: setAssignToMe, editAccessUiState: editAccessUiState, getClientSearchDataList: getClientSearchDataList, getEditURL: getEditLeadURL, getStateObject: __assign({}, getStateObject()), handleOpenModal: function (isShowModal, activeTab) {
                    setIsShowProductFeedbackModal(isShowModal);
                    setProductFeedbackActiveTab(activeTab);
                }, setProductFeedbackModalData: setProductFeedbackModalData, setViewMom: setViewMom, getMomViewDetails: getMomViewDetails, setOrderIdPopUpInfo: setOrderIdPopUpInfo, setViewLead: setViewLead })), footer: "", openKey: viewLead, setOpenKey: setViewLead, arrowClose: true, delay: 10 })),
        showSucess && (React.createElement(GenericToast, { containerPosition: "fixed", backGroundColor: "Light", position: "middle-center", message: showAssignMsg, delay: 3000, autohide: true, title: "Success", close: true, setClose: function () { return setShowSuccess(false); } })),
        React.createElement(EdModal, { show: assignToMe, setShow: setAssignToMe, showFooter: false, modalTitle: "commonmodal sales-client assign-popup", children: React.createElement(React.Fragment, null,
                selfAssignLoader && React.createElement(Loader, null),
                !selfAssignLoader && (React.createElement(AssignLeadPopup, { closePopup: setAssignToMe, getSelfAssign: getSelfAssign, refreshLeadFunction: props.refreshAssingLeadDashboard }))), title: "Assign Lead" }),
        successSelfAssign && (React.createElement(SalesToasts, { show: successSelfAssign, setShow: setSuccessSelfAssign, position: "middle-center", message: React.createElement("span", { dangerouslySetInnerHTML: { __html: successSelfAssignMsg } }), isError: isAssignError, parentClass: "lead-create-toast assign-lead" })),
        editAccessToast && (React.createElement(SalesToasts, { show: editAccessToast, setShow: setEditAccessToast, position: "middle-center", message: React.createElement("span", { dangerouslySetInnerHTML: {
                    __html: editAccessUiState.editAccessMsg,
                } }), isError: editAccessUiState.isEditAccessErrorState, parentClass: "lead-create-toast assign-lead" })),
        React.createElement(EdModal, { show: isShowProductFeedbackModal, setShow: setIsShowProductFeedbackModal, showFooter: false, modalTitle: "commonmodal sales-client assign-popup product-feedback-modal", key: productFeedbackActiveTab, children: React.createElement(GenericTabs, { externalClassName: "common-tab-color", defaultActiveKey: productFeedbackActiveTab, tabsArray: productFeedbackTabs }), title: "Product Feedback", closeDropdown: function () { } }),
        viewMom && (React.createElement("div", { className: "view-mom-popup" },
            React.createElement(EdModal, { show: viewMom, setShow: setViewMom, showFooter: false, modalTitle: "view-mom", children: React.createElement(ViewMom, { setViewMom: setViewMom, momViewLoader: momViewLoader, momViewDetails: momViewDetails, momMailText: momMailText }), title: "", size: "modal-md modal-dialog-centered", closeDropdown: function () { }, stopClossOnOutsideClick: true }))),
        (orderIdPopUpInfo === null || orderIdPopUpInfo === void 0 ? void 0 : orderIdPopUpInfo.isShow) && (React.createElement(SalesWarningPopup, { size: "modal-md modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalwatchlist commonmodal sales-client lead-warning", title: "Warning", showFooter: true, show: orderIdPopUpInfo === null || orderIdPopUpInfo === void 0 ? void 0 : orderIdPopUpInfo.isShow, setShow: function (e) {
                setOrderIdPopUpInfo(function (prev) { return (__assign(__assign({}, prev), { isShow: e })); });
            }, showCloseIcon: true, closeicon: "edel-icon-cross", children: React.createElement("div", { className: "DMSans_16_500 txt_primaryGrey line-140" }, orderIdPopUpInfo === null || orderIdPopUpInfo === void 0 ? void 0 : orderIdPopUpInfo.msg), btnvalueleft: {
                value: "Proceed",
                btnTyp: "midnight-blue",
                onClick: function (e) { return leadRedireactionForOrderID(); },
            }, btnvalueright: {
                value: "Cancel",
                btnTyp: "midnight-blue-border",
                onClick: function (e) {
                    return setOrderIdPopUpInfo(function (prev) { return (__assign(__assign({}, prev), { isShow: false })); });
                },
            }, hideLeftButton: (orderIdPopUpInfo === null || orderIdPopUpInfo === void 0 ? void 0 : orderIdPopUpInfo.url) != null &&
                (orderIdPopUpInfo === null || orderIdPopUpInfo === void 0 ? void 0 : orderIdPopUpInfo.url) != "" &&
                (orderIdPopUpInfo === null || orderIdPopUpInfo === void 0 ? void 0 : orderIdPopUpInfo.url) != undefined
                ? false
                : true }))));
};
export default LeadTableNPagination;
